import styled from "@emotion/styled"
import { Typography, css } from "@mui/material"
import { memo } from "react"

export const TagSmall = (p) => css`
  .wrapper {
    margin: 5px 0;
  }
  .tag {
    font-size: 10px;
    padding: 2px 10px;
    ${p.theme.breakpoints.up("md")} {
      font-size: 14px;
      padding: 3px 14px;
    }
  }
`

export const TagLarge = (p) => css`
  .tag {
    ${p.theme.breakpoints.up("md")} {
      font-size: 18px;
      padding: 6px 16px;
      &:not(:first-of-type) {
        margin-right: 10px;
      }
    }
  }
`

const Styled = {
  Wrapper: styled.div`
    margin: 6px -2.5px;
    display: inline-block;
    font-size: 12px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      margin-bottom: 10px;
    }
  `,
  Tag: styled(Typography)`
    padding: 1px 17px 1px 18px;
    font-size: 12px;
    ${(p) => p.theme.breakpoints.up("md")} {
      padding: 2px 30px;
      font-size: 19px;
    }
    font-weight: bold;
    background-color: ${(p) => p.theme.colors.paleGreyTwo};
    display: inline-block;
    color: ${(p) => p.theme.colors.marine};

    margin: 2.5px;
  `,
}
type VehicleMissonsProps = { data: string[] }

const VehicleMissons = ({ data }: VehicleMissonsProps) => (
  <Styled.Wrapper className="wrapper">
    {data.map((mission, i) => (
      <Styled.Tag className="tag" key={i}>
        {mission}
      </Styled.Tag>
    ))}
  </Styled.Wrapper>
)

export default memo(VehicleMissons)
